// src/LoginPage.js
import React, { useState } from "react";
import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL?.replace(/\/+$/, "") || "";

function decodeJwt(token) {
  try {
    const payload = token.split(".")[1];
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
}

const LoginPage = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [sifre, setSifre] = useState("");
  const [hata, setHata] = useState("");
const [forgotOpen, setForgotOpen] = useState(false);
const [forgotEmail, setForgotEmail] = useState("");
const [forgotMsg, setForgotMsg] = useState("");


const handleForgotPassword = async (e) => {
  e.preventDefault();
  setForgotMsg("");

  try {
    await axios.post("/api/kurum-passport/forgot-password", {
      email: forgotEmail,
    });

    setForgotMsg(
      "Eğer e-posta sistemde kayıtlıysa, şifre yenileme bağlantısı gönderildi."
    );
    setForgotEmail("");
  } catch (err) {
    setForgotMsg(
      "Eğer e-posta sistemde kayıtlıysa, şifre yenileme bağlantısı gönderildi."
    );
  }
};

  const handleLogin = async (e) => {
    e.preventDefault();
    setHata("");

    try {
      const res = await axios.post("/api/giris", { email, sifre });

          if (res.data?.token) {
        localStorage.setItem("token", res.data.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${res.data.token}`;
      }

      let me = res.data?.kullanici || res.data?.user || null;

      if (!me && res.data?.token) {
        const p = decodeJwt(res.data.token);
        if (p) {
          me = {
            id: p.id,
            email: p.email,
            username: p.username,
            name: p.name,
            kurum_id: p.kurum_id,
            sube_id: p.sube_id,
            rol: p.rol || p.role,
            role: p.role || p.rol,
            is_staff_user: p.is_staff_user === true,
            permissions: p.permissions || {},
            branchScope: p.branch_scope || p.branchScope || "all",
            allowed_sube_ids: p.allowed_sube_ids || [],
          };
        }
      }

      if (me) {
        localStorage.setItem("me", JSON.stringify(me));
        localStorage.setItem("kullanici", JSON.stringify(me));
        localStorage.setItem("user", JSON.stringify(me));

        localStorage.setItem("rol", me.rol || me.role || "");
        localStorage.setItem("role", me.role || me.rol || "");
        localStorage.setItem("kurum_id", String(me.kurum_id || ""));
      }

      window.dispatchEvent(new CustomEvent("auth:login", { detail: me }));

      setEmail("");
      setSifre("");

      onLoginSuccess && onLoginSuccess();
    } catch (err) {
      setHata("E-posta veya şifre yanlış");
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-gradient-to-br from-[#0B1E3F] via-[#0F2D59] to-[#1B3C82]">

      {/* Üst Logo + Başlık */}
      <div className="w-full text-center pt-10">
        <h1 className="text-white text-3xl font-bold tracking-wide drop-shadow-lg">
          MesYat Dijital Çözümler Paneli
        </h1>
        <p className="text-white/80 text-sm mt-2">
          Kurum Yönetim Sistemi
        </p>
      </div>

      {/* Giriş Kartı */}
      <div className="flex justify-center px-4">
        <div className="w-full max-w-md bg-white shadow-2xl rounded-2xl p-8 border border-gray-100">

          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Firma Paneli Giriş
          </h2>

          {hata && (
            <div className="text-red-600 text-sm text-center mb-4">
              {hata}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                E-posta
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="mesutyildiz.ch@gmail.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Şifre
              </label>
              <input
                type="password"
                value={sifre}
                onChange={(e) => setSifre(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="••••••••"
                required
              />
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg font-bold transition"
            >
              Giriş Yap
            </button>
          </form>

<div className="text-right mt-3">
  <button
    type="button"
    onClick={() => setForgotOpen(true)}
    className="text-sm text-blue-600 hover:underline"
  >
    Şifremi Unuttum
  </button>
</div>

          {/* Üye Olmak İçin */}
          <p className="text-center text-gray-700 mt-6 text-sm">
            Üye olmak için lütfen iletişime geçiniz.
          </p>
        </div>


      </div>

      {/* Footer / İletişim */}
      <div className="text-center text-white/90 text-sm py-8 space-y-1">
        <div>📞 +41 78 255 88 27</div>
        <div>📞 +90 533 643 76 15</div>
        <div>📧 mesutyildiz.ch@gmail.com</div>
        <div>📍 Zürich / İzmir</div>

        <p className="text-white/60 mt-3">© 2025 Haymes Tasarım</p>
      </div>


{forgotOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-md rounded-xl p-6 shadow-2xl">
      <h3 className="text-xl font-bold text-gray-800 mb-4">
        Kurumsal Şifre Yenileme
      </h3>

      {forgotMsg && (
        <div className="text-green-600 text-sm mb-3">
          {forgotMsg}
        </div>
      )}

      <form onSubmit={handleForgotPassword} className="space-y-4">
        <input
          type="email"
          value={forgotEmail}
          onChange={(e) => setForgotEmail(e.target.value)}
          placeholder="E-posta adresiniz"
          className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-600"
          required
        />

        <div className="flex gap-3">
          <button
            type="submit"
            className="flex-1 bg-blue-600 text-white py-2 rounded-lg font-semibold"
          >
            Gönder
          </button>

          <button
            type="button"
            onClick={() => setForgotOpen(false)}
            className="flex-1 bg-gray-200 text-gray-700 py-2 rounded-lg"
          >
            İptal
          </button>
        </div>
      </form>
    </div>
  </div>
)}




    </div>
  );
};


export default LoginPage;
